export function convertPluginToSchema(plugin) {
    // Convert plugin options into the form schema
    var group = [];

    var options = [...plugin.options].reverse();
    options.forEach(function (p) {
        var option = p;
        var value = p.default;

        var field = {
            label: option.label || p.charAt(0).toUpperCase() + p.slice(1).replace('_', ' '),
            name: p.plugin + '.' + p.attr_name,
            default: value,
            value: value,
            mapping: p.attr_name,
        };

        if (option.description) {
            field.description = option.description;
        }

        if (option.options) {
            field.type = 'select';
            var opts = [];
            for (var i = 0, l = option.options.length; i < l; i++) {
                var opt = {
                    label: option.options[i][0],
                    value: option.options[i][1],
                };
                opts.push(opt);
            }
            field.options = opts.reverse();
        } else {
            if (option.type == 'bool') {
                field.type = 'boolean';
            } else {
                field.type = 'text';
            }
        }

        const index = group.findIndex((f) => f.group === p.group);
        if (index > -1) {
            // section exists
            group[index].fields.push(field);
        } else {
            // new section
            var section = {
                type: 'section',
                group: p.group,
                title: p.plugin == p.group ? 'Options' : p.group,
                collapsed: !(p.plugin == p.group),
                fields: [field],
            };
            group.push(section);
        }
    });

    var orderedGroup = [];
    group.forEach(function(section) {
        if(section.collapsed == false) orderedGroup.push(section);
    });
    group.forEach(function(section) {
        if(section.collapsed == true && section.title != 'Attack Injection Points') orderedGroup.push(section);
    });
    group.forEach(function(section) {
        if(section.title == 'Attack Injection Points') orderedGroup.push(section);
    });

    const schema = {
        type: 'section',
        title: plugin.name,
        fields: orderedGroup,
    };

    return schema;
}